// extracted by mini-css-extract-plugin
export default {"root":"buyer-requisites_root__k2Xk2","heading":"buyer-requisites_heading__I6kdM","saveButton":"buyer-requisites_saveButton__IOGW6"};